import '../cart.js';
//import 'slick-carousel';
import '../form.js';

$(document).ready(function () {
    // Product with optionseries
    if (intProductPricetypeno == 2) {
        // Select another option
        //$('ul.optionseries li select').change(function () {
        $('div.optionserie select').change(function () {
            if ($(this).find(':selected').data('href')) {
                // Go to the url from the option
                document.location = $(this).find(':selected').data('href');
            }
        });
    }

    // Add to cart
    AddToCart($('form#frmAddToCart button#btnAddToCart'), WebsiteSettingBlnShowAddToCartQtyField, true);

    // Mail on stock
    if (WebsiteSettingBlnMailOnStock) {
        // Clicking on button from mail on stock => ajax form
        $('div.mail-on-stock input#btnMailStock').click(function () {
            var objForm = $('form#frmAddToCart');
            var objLi = $('input#txtEmailStock').parent();

            // Check if there's a correct e-mail entered => then add request to database
            $.post(strAjaxPath + 'mail-on-stock.php', 'intArticleNo=' + $('input#hdnArticleNo').val() + '&intPriceNo=' + $('input#hdnPriceNo').val() + '&strEmailStock=' + $('input#txtEmailStock').val(), function (data) {
                $('input#btnMailStock').removeClass('form-error');
                objLi.removeClass('form-error');
                objLi.find('p.form-error').each(function () {
                    $(this).remove();
                });

                if (data.value == 0) {
                    // Error
                    $('input#btnMailStock').addClass('form-error');
                    objLi.addClass('form-error');
                    objLi.append('<p class="form-error">' + data.message + '</p>');
                } else {
                    // Notitication
                    $('div.mail-on-stock ul.form').hide();
                    $('div.mail-on-stock').append('<div class="alert info">' + data.message + '</div>');
                }
            }, 'json');
        });
    }

    // Check if there are linked products with an add-to-cart button
    if (intSizeRelatedProducts > 0) {
        AddToCart($('form.form-add-to-cart button.btn-basket'), false, true);
    }

    //ADD TO WISHLIST
    $('.add-to-wishlist').click(function () {
        var strWishlistArticles = GetLocalStorage('strWishlistArticles');

        var strParams = 'intArticleno=' + $(this).data('article');
        strParams += '&strType=add';
        strParams += '&strWishlistArticles=' + strWishlistArticles;

        $.post(strAjaxPath + 'wishlist/wishlist.php', strParams, function (objResponse) {
            if (objResponse != '') {
                // Save session storage
                SetLocalStorage('strWishlistArticles', objResponse.articles);

                $.post(strAjaxPath + 'wishlist/wishlist-popup.php', strParams, function (data) {
                    $.fancybox.open(
                        data,
                        {
                            afterLoad: function () {
                                $('.add-to-wishlist').addClass('added');


                                // Click on link 'Continue shopping'
                                $('a.readmore.back').click(function () {
                                    // Close popup
                                    $('.fancybox-close-small').click();
                                    return false;
                                });

                                // Click on link 'View wishlist'
                                $('a.parent').click(function () {
                                    parent.window.location = $(this).attr('href');
                                    return false;
                                });

                                // Click on link 'Add new list'
                                $('a.new-list').click(function () {
                                    $(this).toggleClass('active');
                                    $('form#frmWishlist').toggleClass('d-none');
                                    return false;
                                });

                                // Choose another list
                                $('input[type=radio]').click(function () {
                                    var strValue = $(this).val();
                                    var strParams = 'intArticleno=' + intArticleno;
                                    strParams += '&strGiftlistno=' + strValue;

                                    // Update wish list
                                    $.post(strAjaxPath + 'wishlist/wishlist-update-list.php', strParams, function (data) {
                                        if (data == 'OK') {
                                            $('a.parent').attr('href', strPath + strLang + '/wishlist/' + strValue);
                                        }
                                    });
                                });

                                // Validate form
                                FormValidateAddWishlist($('form#frmWishlist'));
                            },
                        },
                    );
                });
            }
        }, 'json');
        return false;
    });

//slider
    if ($('.slider').length > 0) {
        var objSlider = $('.slider').slick({
            adaptiveHeight: true, //maek the height of the slider change to the height of the image
            autoplay: false, // automated sliding of the slider (only activate on client demand !!)
            arrows: true, // left and right arrow to navigate throug the slider
            dots: true, // navigation dots
            fade: false, // fade instead of slide,
            infinite: true, // make the slider infinite scrolling
        });

        // Check the number of thumbs
        var intThumbs = $('div.thumb').length;
        if (intThumbs > 1) {
            $('.thumbs').slick({
                slidesToShow: 5,
                slidesToScroll: 1,
                dots: false,
                centerMode: false,
                infinite: false,
            });
        }
        $('div.thumbs').on('click', '.slick-slide', function () {
            $('.div.thumb').removeClass('slick-current');
            $(this).addClass('slick-current');
            objSlider.slick('slickGoTo', $(this).attr('data-slick-index'));
            return false;
        });
    }

    if (blnCourse) {
        // Check if server side errors for offer form
        if (blnFormOfferErrors || blnSendOffer) {
            // If server side errors => show form in popup
            $('#button-offer').click();
        }

        // Form validate on form 'Ask an offer'
        FormValidateOffer($('form#frmOffer'));

        // Check if server side errors for colleague form
        if (blnFormColleagueErrors || blnSendColleague) {
            // If server side errors => show form in popup
            $('#button-colleague').click();
        }

        // Form validate on form 'Send to a colleague'
        FormValidateColleague($('form#frmColleague'));
    }
});


